import { Box, Button, Grid, Typography } from '@mui/material';
import { ArrowUpIcon } from '../../assets/icons';
import { footerStyles } from './styles';
import Logo from '../../assets/images/logo/nep.png';

export const FooterCopyrightContent: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item>
        <Grid container alignItems="center" spacing={4}>
          <Grid item>
            <Box component="img" src={Logo} sx={{ display: 'block', height: '3.5rem' }} />
          </Grid>
          <Grid item>
            <Typography sx={footerStyles.copyrightContent} color="secondary" component="span" variant="small">
              All rights reserved, {new Date().getFullYear()}
            </Typography>
            <Typography fontWeight="Medium" variant="small" sx={{ ml: 1 }}>
              Version: V1.0
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item sx={footerStyles.gotoTopButton}>
        <Button variant="text" endIcon={<ArrowUpIcon title="Goto top" />} color="secondary" onClick={scrollToTop}>
          Goto top
        </Button>
      </Grid>
    </Grid>
  );
};
